import { readCommunity } from "@/features/community/records";
import { coworldSourceFrom, type CoworldSource } from "./coworld-source";
import { safeManifestUrl } from "./manifest-record";
export async function readCoworldManifest({
  signal,
  coworldId,
}: {
  signal?: AbortSignal | undefined;
  coworldId: string | null;
}): Promise<
  | {
      manifest: unknown;
      source: CoworldSource;
      documentationUrl: string | null;
    }
  | "private"
  | null
> {
  if (!coworldId) return null;

  const result = await readCommunity<{
    manifest?: unknown;
    documentation_url?: string;
  }>({
    signal,
    path: `/v2/coworlds/${coworldId}`,
  });

  if (result.status === "not-found") return "private";

  const body = result.status === "ok" ? result.data : null;

  if (!body || typeof body !== "object" || !("manifest" in body)) {
    return null;
  }

  return {
    manifest: body.manifest,
    source: coworldSourceFrom(body.manifest),
    documentationUrl: safeManifestUrl(body.documentation_url),
  };
}
